import * as React from 'react';
import { IListViewFieldColumn } from "../../../../../services/ViewService";
import { ProjectInfo } from "../../../../../store/ProjectsListStore";
import { SourceInfo, ISourceInfo } from "../../../../../entities/common";
import { SourceTypeMap } from "../../../../../store/ExternalEpmConnectStore";
import { Field } from '../../../../../entities/Metadata';
import { FormatDateTime, toDateTime } from '../../../../utils/common';

export default class SyncDate extends React.Component<IListViewFieldColumn<ProjectInfo>, { lastSyncDate: string | null, title: string }> {
    constructor(props: IListViewFieldColumn<ProjectInfo>) {
        super(props);
        this.state = { lastSyncDate: null, title: "" };
    }

    componentWillMount() {
        this.setState({
            lastSyncDate: SyncDate.getLastSyncDate(this.props.entity.sourceInfos),
            title: SyncDate.getTitle(this.props.entity.sourceInfos)
        });
    }

    componentWillReceiveProps(nextProps: IListViewFieldColumn<ProjectInfo>) {
        if (this.props.entity.sourceInfos !== nextProps.entity.sourceInfos) {
            this.setState({
                lastSyncDate: SyncDate.getLastSyncDate(nextProps.entity.sourceInfos),
                title: SyncDate.getTitle(nextProps.entity.sourceInfos)
            });
        }
    }

    public render() {
        const field = this.props.field;
        if (!field) {
            return <span>Invalid column configuration</span>;
        }

        return (
            <span title={this.state.title}>{this.state.lastSyncDate}</span>
        );
    }

    private static getLastSyncDate(dataSources: ISourceInfo[]): string | null {
        const sources = SourceInfo.getDataConnections(SourceInfo.getSyncableConnections(dataSources));
        if (!sources.length) {
            return null;
        }

        const lastSyncDate = sources[0].syncStatus.lastSyncDate;

        return lastSyncDate
            ? FormatDateTime(lastSyncDate, true,
                {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                })!
            : "";
    }

    private static getTitle(dataSources: ISourceInfo[]): string {
        const sources = SourceInfo.getDataConnections(SourceInfo.getSyncableConnections(dataSources));

        return sources
            .filter(_ => !!_.syncStatus.lastSyncDate)
            .map(source => `${SourceTypeMap[source.type]}: ${FormatDateTime(source.syncStatus.lastSyncDate!, true,
                {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                })}`)
            .join("\n");
    }

    public static getValue(entity: ProjectInfo, field: Field): Date | undefined {
        const sources = SourceInfo.getSources(entity.sourceInfos);
        if (!sources.length) {
            return undefined;
        }

        const lastSyncDate = sources[0].syncStatus.lastSyncDate;

        return lastSyncDate ? toDateTime(lastSyncDate)! : undefined;
    }

    public static getSearchValue(entity: ProjectInfo, field: Field): string | null {
        return SyncDate.getLastSyncDate(entity.sourceInfos)
    }
}